const mixpanelWrapper = {
  identify(uniqueId) {
    if (window.mixpanel) {
      window.mixpanel.identify(uniqueId);
    }
  },
  register(properties) {
    if (window.mixpanel) {
      window.mixpanel.register(properties);
    }
  },
  track(eventName, properties, callback) {
    if (window.mixpanel) {
      window.mixpanel.track(eventName, properties, callback);
    }
  },
  people: {
    set(properties, callback) {
      if (window.mixpanel) {
        window.mixpanel.people.set(properties, callback);
      }
    },
    set_once(properties, callback) {
      if (window.mixpanel) {
        window.mixpanel.people.set_once(properties, callback);
      }
    }
  }
};

export default mixpanelWrapper;
